import React from 'react'
import { Link } from 'react-router-dom'
import moment from "moment"

const Question = ({ question }) => {
    return (
        <div className="display-question-container">
            <div className="display-votes-ans">
                <p>{question.upvote.length - question.downvote.length}</p>
                <p>votes</p>
            </div>
            <div className="display-votes-ans">
                <p>{question.noofanswers}</p>
                <p>answers</p>
            </div>
            <div className="display-question-details">
                <Link to={`/Question/${question._id}`} className='question-title-link'>
                    {question.questiontitle.length > (window.innerWidth <= 400 ? 70 : 90)
                        ? question.questiontitle.substring(
                            0,
                            window.innerWidth <= 400 ? 70 : 90
                        ) + "..."
                        : question.questiontitle
                    }
                </Link>
                <div className="display-tags-time">
                    <div className="display-tags">
                        {question.questiontags.map((tag) => (
                            <p key={tag}> {tag}</p>
                        ))}
                        {question.videoUrl && (
                            <span style={{ marginLeft: '10px', color: '#0077cc' }}>
                                <i className="fa-solid fa-video"></i> Video
                            </span>
                        )}
                    </div>
                    <p className="display-time">
                        asked {moment(question.askedon).fromNow()} {question.userposted}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Question